import React, { useMemo, useEffect } from 'react';
import './index.scss';
import { Link, useHistory } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import AssemblyCard from '../../components/AssemblyCard/AssemblyCard';

import DwellersList from '../../components/DwellersList/DwellersList';
import useMe from '../../hooks/useMe';
import useContext from '../../hooks/useContext';
import ChangeCondominiumWidget from '../../components/ChangeCondominiumWidget';

const optionDescriptionDashboardFragment = gql`
  fragment optionDescriptionDashboardFragment on Option {
    _id
    description
    votes
  }
`;

const commentsDashboardFragment = gql`
  fragment commentsDashboardFragment on Comment {
    user
  }
`;

const dataGql = gql`
  query condominium($condominiumId: ID) {
    condominium(condominiumId: $condominiumId) {
      _id
      name
      referral
      dwellersCount
      assemblies {
        _id
        description
        condominium
        status
        type
        subjects {
          _id
          title
          description
          options {
            ...optionDescriptionDashboardFragment
          }
          comments {
            ...commentsDashboardFragment
          }
        }
      }
    }
  }
  ${commentsDashboardFragment}
  ${optionDescriptionDashboardFragment}
`;

export default function Dashboard() {
  const [me, fetchMe] = useMe();
  const history = useHistory();
  const { isLoading, isJanitor, approved, condominiumId, status } = useContext();

  const { data: dataResult, loading, refetch } = useQuery(dataGql, {
    skip: isLoading || !condominiumId || !me,
    variables: {
      condominiumId,
    },
    fetchPolicy: 'no-cache',
  });

  const condominium = useMemo(() => {
    if (!dataResult) return undefined;

    return dataResult.condominium;
  }, [dataResult]);

  useEffect(() => {
    fetchMe();
  }, []);

  useEffect(() => {
    if (condominium && status === 'rejected') {
      history.push(`/${condominium.referral}`);
    }
  }, [status, condominium, history]);

  return (
    <div className="dashboard h-100 d-flex flex-column ">
      {!condominium || loading ? (
        <div className="justify-content-center d-flex p-3">
          <h4>Carregando..</h4>
        </div>
      ) : (
        <>
          <div className="justify-content-center text-center d-flex p-3">
            <ChangeCondominiumWidget />
          </div>
          {isJanitor && condominium && <DwellersList condominium={condominium} />}

          {!approved && !isJanitor && (
            <div className="d-flex justify-content-space-between flex-column align-items-center p-5">
              <p className="text-center">
                Sua solicitação para participar da assembleia foi enviada!
                <br />
                <br />
                Você será avisado por e-mail quando for aprovado.
              </p>
            </div>
          )}
          {approved && (
            <div className="row mb-2">
              <div className="col">
                <h6>Assembleias e reuniões</h6>
              </div>
            </div>
          )}
          {!condominium.assemblies.length && (isJanitor || approved) && (
            <div className="d-flex justify-content-space-between flex-column align-items-center p-5">
              <p>):</p>
              <p className="text-center">Você ainda não possui assembleias</p>
            </div>
          )}

          {condominium.assemblies && condominium.assemblies.length > 0 && (isJanitor || approved) && (
            <div className="list-group dashboard">
              {condominium.assemblies &&
                condominium.assemblies.map(assembly => (
                  <AssemblyCard
                    assembly={assembly}
                    isJanitor={isJanitor}
                    key={assembly._id}
                    onCompleted={() => refetch()}
                  />
                ))}
            </div>
          )}
          {isJanitor && (
            <>
              <div className="align-bottom justify-content-end">
                <Link className="btn btn-primary btn-block" to={`/condominiums/${condominium._id}/assembly/register`}>
                  Nova Assembleia
                </Link>
              </div>
              <div className="align-bottom justify-content-end mt-3">
                <Link
                  className="btn btn-outline-primary btn-block"
                  to={`/condominiums/${condominium._id}/meeting/register`}
                >
                  Nova Reunião
                </Link>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
